import { render, staticRenderFns } from "./UpgradeSettings.vue?vue&type=template&id=52f24b80"
import script from "./UpgradeSettings.vue?vue&type=script&lang=js"
export * from "./UpgradeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports